class CustomNavigation extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // 获取DOM元素
    this.header = this.querySelector('.custom-navigation-container');
    this.searchButton = this.querySelector('.custom-navigation__search');
    this.searchModal = this.querySelector('.search-modal');
    this.dropdownItems = this.querySelectorAll('.list-menu__item');
    this.mobileToggle = this.querySelector('.mobile-toggle-menu');
    this.mobileMenu = this.querySelector('.mobile-menu');
    this.mobileSubmenuToggles = this.querySelectorAll('.mobile-submenu-toggle');
    
    // 绑定事件
    this.bindEvents();

    // 添加hover效果
    this.setupHoverEffects();
    
    // 移动端菜单处理
    this.setupMobileMenu();
  }

  bindEvents() {
    // 窗口大小改变时触发响应式布局调整
    window.addEventListener('resize', this.handleResize.bind(this));
    
    // 页面滚动事件
    window.addEventListener('scroll', this.handleScroll.bind(this));
    
    // 点击其他地方关闭搜索框
    document.addEventListener('click', this.handleDocumentClick.bind(this));
    
    // 移动端菜单切换
    if (this.mobileToggle) {
      this.mobileToggle.addEventListener('click', this.toggleMobileMenu.bind(this));
    }
    
    // 移动端子菜单切换
    this.mobileSubmenuToggles.forEach(toggle => {
      toggle.addEventListener('click', this.toggleMobileSubmenu.bind(this));
    });
  }

  setupHoverEffects() {
    // 为操作按钮添加hover效果
    const actionButtons = this.querySelectorAll('.hover-effect');
    actionButtons.forEach(button => {
      button.addEventListener('mouseenter', () => {
        this.animateScale(button);
      });
    });
  }

  animateScale(element) {
    // 鼠标悬停时的放大动画效果
    element.style.transition = 'transform 0.2s ease';
    // 从CSS变量获取放大比例
    const scale = getComputedStyle(this.header).getPropertyValue('--hover-scale') || 1.2;
    
    // 只有当元素不是已经放大状态时才执行
    if (element.style.transform !== `scale(${scale})`) {
      element.style.transform = `scale(${scale})`;
      
      // 动画结束后恢复原始大小
      setTimeout(() => {
        element.style.transform = 'scale(1)';
      }, 300);
    }
  }

  toggleMobileMenu(event) {
    event.preventDefault();
    
    // 更新汉堡菜单按钮状态
    const isExpanded = this.mobileToggle.getAttribute('aria-expanded') === 'true';
    this.mobileToggle.setAttribute('aria-expanded', !isExpanded);
    
    // 切换汉堡菜单图标
    const hamburgerLines = this.mobileToggle.querySelectorAll('.hamburger-line');
    if (hamburgerLines.length === 3) {
      if (isExpanded) {
        // 恢复原始汉堡图标
        hamburgerLines[0].style.transform = 'none';
        hamburgerLines[1].style.opacity = '1';
        hamburgerLines[2].style.transform = 'none';
      } else {
        // 变成关闭图标 (X)
        hamburgerLines[0].style.transform = 'rotate(45deg) translate(5px, 5px)';
        hamburgerLines[1].style.opacity = '0';
        hamburgerLines[2].style.transform = 'rotate(-45deg) translate(5px, -5px)';
      }
    }
    
    // 切换菜单可见性
    this.mobileMenu.classList.toggle('open');
    this.mobileMenu.setAttribute('aria-hidden', isExpanded);
  }

  toggleMobileSubmenu(event) {
    event.preventDefault();
    
    const toggle = event.currentTarget;
    const submenu = toggle.nextElementSibling;
    const isExpanded = toggle.classList.contains('open');
    
    // 更新切换按钮状态
    toggle.classList.toggle('open');
    
    // 切换子菜单可见性
    if (submenu && submenu.classList.contains('mobile-submenu')) {
      submenu.classList.toggle('open');
    }
  }

  setupMobileMenu() {
    // 检测是否是移动设备
    if (window.innerWidth < 990) {
      this.setupMobileMenuLayout();
    }
  }

  setupMobileMenuLayout() {
    // 移动端菜单的布局调整
    const menu = this.querySelector('.custom-navigation__menu');
    if (menu) {
      // 确保菜单可以水平滚动
      const listMenu = menu.querySelector('.list-menu--inline');
      if (listMenu) {
        listMenu.setAttribute('role', 'list');
        listMenu.style.display = 'flex';
        listMenu.style.overflowX = 'auto';
      }
    }
  }

  handleResize() {
    // 处理窗口大小变化
    if (window.innerWidth < 990) {
      this.setupMobileMenuLayout();
      
      // 如果屏幕变小，确保桌面菜单关闭
      if (this.mobileMenu && this.mobileMenu.classList.contains('open')) {
        // 保持移动菜单打开状态
      } else {
        this.mobileMenu.classList.remove('open');
        this.mobileMenu.setAttribute('aria-hidden', 'true');
        if (this.mobileToggle) {
          this.mobileToggle.setAttribute('aria-expanded', 'false');
          
          // 恢复汉堡图标
          const hamburgerLines = this.mobileToggle.querySelectorAll('.hamburger-line');
          if (hamburgerLines.length === 3) {
            hamburgerLines[0].style.transform = 'none';
            hamburgerLines[1].style.opacity = '1';
            hamburgerLines[2].style.transform = 'none';
          }
        }
      }
    } else {
      // 恢复桌面布局
      const menu = this.querySelector('.custom-navigation__menu');
      if (menu) {
        menu.style.order = '';
      }
      
      // 如果屏幕变大，确保移动菜单关闭
      if (this.mobileMenu) {
        this.mobileMenu.classList.remove('open');
        this.mobileMenu.setAttribute('aria-hidden', 'true');
      }
      
      if (this.mobileToggle) {
        this.mobileToggle.setAttribute('aria-expanded', 'false');
        
        // 恢复汉堡图标
        const hamburgerLines = this.mobileToggle.querySelectorAll('.hamburger-line');
        if (hamburgerLines.length === 3) {
          hamburgerLines[0].style.transform = 'none';
          hamburgerLines[1].style.opacity = '1';
          hamburgerLines[2].style.transform = 'none';
        }
      }
    }
  }

  handleScroll() {
    // 滚动时的效果，比如固定导航栏
    if (window.scrollY > 50) {
      this.header.classList.add('scrolled');
    } else {
      this.header.classList.remove('scrolled');
    }
  }

  handleDocumentClick(event) {
    // 点击页面其他区域关闭搜索框
    if (this.searchModal && this.searchButton) {
      const details = this.searchButton.querySelector('details');
      if (details && details.open && !details.contains(event.target)) {
        details.open = false;
      }
    }
    
    // 点击页面其他区域关闭移动菜单（可选功能）
    if (this.mobileMenu && this.mobileToggle) {
      if (
        this.mobileMenu.classList.contains('open') && 
        !this.mobileMenu.contains(event.target) && 
        !this.mobileToggle.contains(event.target)
      ) {
        this.toggleMobileMenu(event);
      }
    }
  }
}

// 注册自定义元素
customElements.define('custom-navigation', CustomNavigation);

// 当DOM加载完成后初始化导航
document.addEventListener('DOMContentLoaded', () => {
  // 添加自定义导航标签用于初始化
  const navSections = document.querySelectorAll('.custom-navigation-container');
  navSections.forEach(section => {
    const parent = section.parentElement;
    if (parent && !parent.matches('custom-navigation')) {
      const customNav = document.createElement('custom-navigation');
      parent.insertBefore(customNav, section);
      customNav.appendChild(section);
    }
  });
}); 